<template>
    <b-modal id="modal1" title="사용자 추가" hide-footer v-if="show">
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="메일 사용자 아이디" label-for="mailuser">
          <b-form-input id="mailuser" type="text" v-model="form.mailuser" required placeholder="도메인(예: @seoulsound.com)을 제외한 이메일을 입력하세요"></b-form-input>
        </b-form-group>
        <b-form-group label="메일 도메인" label-for="mailhost">
          <b-form-select id="mailhost"
                      :options="mailhosts"
                      required
                      v-model="form.mailhost">
          </b-form-select>
        </b-form-group>
        <b-form-group label="사용자명" label-for="name">
          <b-form-input id="name" type="text" v-model="form.name" required placeholder="사용자 이름을 입력하세요"></b-form-input>
        </b-form-group>
        <b-form-group label="비밀번호" label-for="password">
          <b-form-input id="password" type="password" v-model="form.password" required placeholder="비밀번호를 입력하세요"></b-form-input>
        </b-form-group>
        <b-form-group label="비밀번호 확인" label-for="passwordRepeat">
          <b-form-input id="passwordRepeat" type="password" v-model="form.passwordRepeat" required placeholder="비밀번호를 한 번 더 입력하세요"></b-form-input>
          <div class="invalid-feedback">
            입력하신 비밀번호가 다릅니다
          </div>
        </b-form-group>
        <b-button type="submit" variant="primary">저장</b-button>
      </b-form>
    </b-modal>
</template>

<script>
export default {
  data() {
    return {
      mailhosts: [
        'seoulsound.com', 'dreamsound.com', 'outlook.klausys.com'
      ],
      form: {
        mailuser: '',
        mailhost: '',
        name: '',
        password: '',
        passwordRepeat: ''
      },
      show: true
    };
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault();
      if (this.form.password != this.form.passwordRepeat) {
        alert('입력하신 비밀번호가 다릅니다. 비밀번호를 확인해주세요.')
      } else {
        this.$http.post('crew/', this.form)
        .then(response => {
          window.console.log(response)
          alert('사용자를 추가했습니다. 비밀번호: ' + this.form.password)
          this.form = {}
          this.show = false
          this.$nextTick(() => { this.show = true })
        })
        .catch(error => {
          window.console.log(error)
          alert('오류가 발생했습니다.')
        })
      }      
    },
    onReset (evt) {
      evt.preventDefault();
      this.form = {}
      this.show = false
      this.$nextTick(() => { this.show = true })
    }
  }
}
</script>
